<script>
  import Cube from './components/Cube.svelte'
</script>

<style>
  :global(html, body) {
    margin: 0;
    padding: 0;
    background: rgb(174, 194, 238);
    background: radial-gradient(
      circle,
      rgba(174, 194, 238, 1) 0%,
      rgba(73, 152, 245, 1) 100%
    );
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  main {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
</style>

<main>
  <Cube enabled={true} />
</main>
